import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b22fc68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "electricity-usage"
}
const _hoisted_2 = { class: "electricity-usage__title h4" }
const _hoisted_3 = { class: "electricity-usage__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.description), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.isUsageExact,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isUsageExact) = $event)),
          class: "electricity-usage__usage-type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: true,
              label: "Enter exact amount",
              "input-id": "is-usage-exact"
            }),
            (_ctx.isUsageExact)
              ? (_openBlock(), _createBlock(_component_InputField, {
                  key: 0,
                  modelValue: _ctx.exactUsageKwh,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exactUsageKwh) = $event)),
                  "has-error": _ctx.isUsageOutOfRange,
                  "error-message": _ctx.usageErrorMessage,
                  label: "Amount (kWh)",
                  name: "exact-usage-kwh",
                  type: "number",
                  required: ""
                }, null, 8, ["modelValue", "has-error", "error-message"]))
              : _createCommentVNode("", true),
            _createVNode(_component_RadioButton, {
              value: false,
              label: "Help me estimate",
              "input-id": "is-usage-estimated"
            })
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_AppButton, {
          class: "electricity-usage__next-button",
          disabled: !_ctx.usageSelected,
          "full-width": "",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.isUsageExact
          ? _ctx.pageContent.nextStepButtonCopy
          : _ctx.pageContent.helpEstimateButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}